<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="8" class="mt-4">
        <v-data-table
          :headers="headers"
          :items="cartItems"
          :items-per-page="totalItemsCount"
          class="elevation-1 schedule-table cart-table mt-4"
          hide-default-footer
        >
          <template v-slot:item.thumb="{ item }">
            <img
              :src="item.thumb"
              alt
              height="50px"
              width="50px"
              class="teacher-img addToWishlist"
              v-if="item.thumb"
              @click="viewProduct(item.id)"
            />
            <img
              src="../../assets/images/women.png"
              alt
              height="50px"
              width="50px"
              class="teacher-img addToWishlist"
              v-else
              @click="viewProduct(item.id)"
            />
          </template>

          <template v-slot:item.name="{ item }">
            <p class="main-color addToWishlist" @click="viewProduct(item.id)">
              <strong>{{ item.name }}</strong>
            </p>
          </template>

          <template v-slot:item.price="{ item }">
            <p class="main-color">{{ item.price }} {{ $t("currency") }}</p>
          </template>

          <template v-slot:item.quantity="{ item }">
            <p class="quantity" style="min-width: 120px;">
              <span class="add-icon" @click="increaseQuantity(item)">
                <v-icon color="#ffc382">add</v-icon>
              </span>
              <span class="grey--text quantity-value">
                <input
                  type="number"
                  v-model="item.quantity"
                  class="form-controls quantity-input"
                  @change="quantityChanged(item)"
                  min="1"
                />
              </span>
              <span class="remove-icon" @click="decreaseQuantity(item)">
                <v-icon color="#ffc382">remove</v-icon>
              </span>
            </p>
          </template>

          <template v-slot:item.total_price="{ item }">
            <p class="main-color">
              {{ item.price * item.quantity }} {{ $t("currency") }}
            </p>
          </template>

          <template v-slot:item.remove="{ item }">
            <v-btn class="text-center" icon @click="removeFromCart(item.id)">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>

        <div class="totol-cart ">
          <v-row>
            <v-col>
              <p :class="locale == 'en' ? 'text-left' : 'text-right'">
                <span class="main-color"
                  ><strong>{{ $t("subTotal") }}: </strong></span
                >
                <span class="second-color"
                  >{{ subTotal }} {{ $t("currency") }}</span
                >
              </p>
            </v-col>
            <v-col :class="locale == 'en' ? 'text-right' : 'text-left'">
              <div>
                <v-btn
                  color="#187e89"
                  class="white--text"
                  v-if="cartItems.length > 0"
                  @click="updateCart"
                  :disabled="!cartChanged"
                >
                  <!-- <v-icon>refresh</v-icon> -->
                  {{ $t("updateCart") }}</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- <div class="text-center pagination">
          <v-pagination
            v-model="page"
            :length="total"
            color="#ffc382"
          ></v-pagination>
        </div> -->
      </v-col>
      <v-col cols="12" md="4" class="mt-4">
        <div class="card-summary">
          <v-row>
            <v-col
              ><h3 class="main-color text-center">
                {{ $t("orderSummary") }}
              </h3></v-col
            >
          </v-row>
          <v-row v-for="(product, index) in cartItems" :key="index">
            <v-col cols="6">
              <p class="main-color">
                <strong>
                  {{ product.name }}
                </strong>
              </p>
            </v-col>
            <v-col cols="2"
              ><p class="grey--text">{{ product.quantity }}x</p></v-col
            >
            <v-col cols="4">
              <p class="main-color">
                <strong>
                  {{ product.quantity * product.price }} {{ $t("currency") }}
                </strong>
              </p>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="8">
              <p class="main-color">
                <strong>
                  {{ $t("subTotal") }}
                </strong>
              </p>
            </v-col>

            <v-col cols="4">
              <p class="main-color">
                <strong>
                  {{ subTotal }}
                  {{ $t("currency") }}
                </strong>
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <p class="main-color">
                <strong>
                  {{ $t("shippingFees") }}
                </strong>
              </p>
            </v-col>

            <v-col cols="4">
              <p class="main-color">
                <strong>
                  {{ 10 }}
                  {{ $t("currency") }}
                </strong>
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p class="main-color">
                <strong> {{ $t("totalFees") }} : </strong>
                <strong
                  >{{ subTotal + 10 }}
                  {{ $t("currency") }}
                </strong>
              </p>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="text-center" v-if="cartItems.length > 0">
              <v-btn
                color="#187e89"
                class="white--text"
                width="80%"
                @click="goToCheckout"
                >{{ $t("checkout") }}</v-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <v-row class="favourites">
      <v-col cols="12"
        ><h2 class="main-color">{{ $t("wishlist") }}</h2></v-col
      >
      <v-col
        cols="4"
        sm="1"
        md="2"
        v-for="(product, index) in favouriteProducts"
        :key="index"
      >
        <v-img
          :src="product.thumb != '' ? product.thumb : defaultProductImg"
          @click="viewProduct(product.id)"
          class="addToWishlist"
        >
          <span class="cart-icon" @click.stop="addToCart(product.id)">
            <v-icon color="#ffffff">shopping_cart</v-icon>
          </span>
        </v-img>
        <p
          class="text-center white--text addToWishlist"
          style="background: #297e89;padding-top:10px"
          @click="viewProduct(product.id)"
        >
          <strong>{{ product.name }}</strong
          ><br />
          <strong>{{ product.price }} {{ $t("currency") }}</strong>
        </p>
      </v-col>
    </v-row>
    <Snack ref="snack"></Snack>
  </v-container>
</template>

<script>
export default {
  name: "Cart",
  data() {
    return {
      locale: localStorage.locale,
      defaultProductImg: require("../../assets/images/favorite-item.png"),
      page: 1,
      total: 1,
      headers: [
        {
          text: "",
          align: "center",
          sortable: false,
          value: "thumb"
        },

        {
          text: "",
          value: "name",
          align: "center",
          sortable: false
        },
        {
          text: "",
          value: "price",
          align: "center",
          sortable: false
        },
        {
          text: "",
          value: "quantity",
          align: "center",
          sortable: false
        },
        {
          text: "",
          value: "total_price",
          align: "center",
          sortable: false
        },

        {
          text: "",
          value: "remove",
          align: "center",
          sortable: false
        }
      ],
      cartItems: [],
      totalItemsCount: 10,
      subTotal: "",
      totalQuantity: "",
      favouriteProducts: [],
      isLoggedIn:
        localStorage.isLoggedIn != undefined &&
        localStorage.isLoggedIn == "true"
          ? true
          : false,
      cartChanged: false
    };
  },
  methods: {
    getCartData() {
      this.$http
        .get(
          this.getApiUrl +
            "/market/cart?cartID=" +
            (localStorage.cartID && localStorage.cartID != undefined
              ? localStorage.cartID
              : ""),
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale
            }
          }
        )
        .then(response => {
          if (response.data.status.error == false) {
            this.cartItems = response.data.data.cartItems;
            this.subTotal = response.data.data.subTotal;
            this.totalQuantity = response.data.data.totalQuantity;
            this.totalItemsCount = this.cartItems.length;
          }
        });
    },
    removeFromCart(id) {
      if (confirm(this.$i18n.t("delete_cart_confirm_message"))) {
        this.$http
          .get(
            this.getApiUrl +
              "/market/cart/remove/" +
              id +
              "?cartID=" +
              (localStorage.cartID && localStorage.cartID != undefined
                ? localStorage.cartID
                : ""),
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                locale: localStorage.locale
              }
            }
          )
          .then(response => {
            if (response.data.status.error == false) {
              this.getCartData();
            }
            this.$bus.$emit("cartChanged");
          });
      }
    },
    viewProduct(id) {
      this.$router.push({ path: "/market/product/" + id });
    },
    getfavouriteProducts() {
      this.$http
        .get(this.getApiUrl + "/market/wishlist?get=6", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            this.favouriteProducts = response.data.data;
          }
        });
    },
    addToCart(id) {
      this.$http
        .post(
          this.getApiUrl + "/market/cart/add",
          {
            product_id: id,
            cartID:
              localStorage.cartID && localStorage.cartID != undefined
                ? localStorage.cartID
                : ""
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale
            }
          }
        )
        .then(response => {
          if (response.data.status.error == false) {
            this.$refs.snack.sendSuccessAlert(response.data.status.message);
            if (response.data.data.cartID != undefined) {
              localStorage.cartID = response.data.data.cartID;
            }
            this.getCartData();
            this.$bus.$emit("cartChanged");
          } else {
            this.$refs.snack.sendErrorAlert(response.data.status.message);
          }
        });
    },
    increaseQuantity(item) {
      item.quantity++;
      this.calculateSubtotal();
    },
    decreaseQuantity(item) {
      if (item.quantity > 1) {
        item.quantity--;
        this.calculateSubtotal();
      }
    },
    calculateSubtotal() {
      this.cartChanged = true;
      /* eslint-disable */
      var subTotal = 0;
      /* eslint-enable */
      this.cartItems.forEach(item => {
        subTotal += parseInt(parseInt(item.quantity) * parseInt(item.price));
      });
      this.subTotal = subTotal;
    },
    quantityChanged(item) {
      console.log(item.quantity);
      if (
        item.quantity == null ||
        item.quantity == "" ||
        item.quantity == undefined ||
        item.quantity == 0
      )
        item.quantity = 1;
      this.calculateSubtotal();
    },
    updateCart() {
      this.$http
        .post(
          this.getApiUrl + "/market/cart/update",
          {
            cartID:
              localStorage.cartID && localStorage.cartID != undefined
                ? localStorage.cartID
                : "",
            cartItems: this.cartItems
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale
            }
          }
        )
        .then(response => {
          if (response.data.status.error == false) {
            this.$refs.snack.sendSuccessAlert(response.data.status.message);
            this.getCartData();
          } else {
            this.$refs.snack.sendErrorAlert(response.data.status.message);
          }
          this.cartChanged = false;
          this.$bus.$emit("cartChanged");
        });
    },
    goToCheckout() {
      if (!this.isLoggedIn) {
        this.$router.push({ path: "/market/login" });
      } else {
        this.$router.push({ path: "/market/checkout" });
      }
    }
  },
  mounted() {
    this.getCartData();
    if (this.isLoggedIn) {
      this.getfavouriteProducts();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";

.cart-table {
  .quantity-input {
    max-width: 3rem;
    text-align: center;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
}
.quantity {
  .quantity-value {
    padding: 0 10px;
  }
  .add-icon,
  .remove-icon {
    display: inline-block;
    border: 1px solid yellow;
    background-color: #ffe6cb;
    color: #ffc382 !important;
    border-radius: 5px;
    cursor: pointer;
  }
}

.card-summary {
  box-shadow: 0px 2px 11px #0000000f;
  padding: 1.5rem;
  margin: 1rem;
}

.margin-top {
  margin-top: 4rem !important;
}

.favourites {
  .cart-icon {
    position: absolute;
    background-color: #ffc382;
    border-radius: 5px;
    display: inline-block;
    bottom: 0;
    padding: 5px;
    margin: 5px;
    cursor: pointer;
  }
}
.addToWishlist {
  cursor: pointer;
}
</style>
